import createErrorHandler from 'utils/createErrorHandler';

export default function validateBlacklistAddModalErrors(
  entityInput,
  pauseStartDate,
  pauseEndDate
) {
  const [errors, addError] = createErrorHandler();

  if (!entityInput) {
    addError('email', 'Please enter Learner Email.');
    return errors;
  } else if (!pauseStartDate) {
    addError('start_date', 'Enter the correct pause from date');
    return errors;
  } else if (!pauseEndDate) {
    addError('end_date', 'Enter the correct pause end Date!');
    return errors;
  }
  return false;
}
